import React from 'react';
import { cn } from '@/utils';

export type ResultTabType = 'pending' | 'rollback';

interface ResultTabsProps {
  value: ResultTabType;
  onChange: (value: ResultTabType) => void;
}

const ResultTabs: React.FC<ResultTabsProps> = ({ value, onChange }) => {
  return (
    <div className="inline-flex gap-2 rounded-md border border-primary-golden/30 bg-black/20 shadow-lg p-1.5 my-2">
      <button
        onClick={() => onChange('pending')}
        className={cn(
          'px-4 py-1.5 text-sm font-medium rounded-md transition-all ',
          value === 'pending'
            ? 'bg-primary-golden text-primary-foreground shadow'
            : 'text-white/60 hover:text-white'
        )}
      >
        Pending Results
      </button>

      <button
        onClick={() => onChange('rollback')}
        className={cn(
          'px-4 py-1.5 text-sm font-medium rounded-md transition-all',
          value === 'rollback'
            ? 'bg-primary-golden text-primary-foreground shadow'
            : 'text-white/60 hover:text-white'
        )}
      >
        Rollback Results
      </button>
    </div>
  );
};

export default ResultTabs;
